module.exports = __webpack_public_path__ + "img/info.004.66abed43.jpeg";